/**
 * Handle insurance checking form, check if
 * customer with particular citizenship needs
 * visa to destination country.
 *
 */
import React from 'react';

/** Custom import's */
import { Container } from '../../store';
import pushNonInteractionEvent from '../../application/utils/ga/pushNonInteractionEvent';

/**
 * Keep state handling inside Container
 * also fetching data or changing data.
 */
class InsuranceCheckingContainer extends Container {
  /**
   * Initialize state in constructor - if You like for example fetch
   *
   * EXAMPLE:
   * constructor(...props or props = {}) {
   *   super();
   *   this.state = {
   *     destinations: props.destinations,
   *   };
   * }
   *
   */
  state = {
    isSchengenEvent: null,
    citizenship: null,
    destination: null,
    insuranceRelevancyResult: null,
    schengenResultID: '',
    schengenColor: '#434875',
    schengenBgColor: '#ffffff',
  };

  /**
   * Handlle Citizenschip Field Change
   */
  handleCitizenshipChange = (citizenship) => {
    this.setState(
      (state) => ({
        citizenship,
      }),
      () => this.checkInsuranceRelevancy(),
    );
  };

  /**
   * Handle Destination Field Change
   */
  handleDestinationChange = (destination) => {
    this.setState(
      (state) => ({
        destination,
      }),
      () => {
        this.checkInsuranceRelevancy();
      }
    );
  };

  checkInsuranceRelevancy = () => {
    const { citizenship, destination } = this.state;
  
    if(!citizenship || !destination) return;

    const pushEvent = (eventLabel) => pushNonInteractionEvent('Insurance|Interest', `${citizenship.name.en}|${destination.name.en}`, eventLabel);

    if(citizenship.needsVisa && destination.isSchengen) {   
      pushEvent('result-1');
      this.setState({ insuranceRelevancyResult: 1}); 
    }

    if(!citizenship.needsVisa && !citizenship.isSchengen && destination.isSchengen) {
      pushEvent('result-2');
      this.setState({ insuranceRelevancyResult: 2});
    }

    if(citizenship.isSchengen && destination.isSchengen) {
      pushEvent('result-3');
      this.setState({ insuranceRelevancyResult: 3});
    }

    if(!destination.isSchengen) {
      pushEvent('result-4');
      this.setState({ insuranceRelevancyResult: 4});
    }

  };
}

let insuranceStore = new InsuranceCheckingContainer();

export { insuranceStore };

export default InsuranceCheckingContainer;



// WEBPACK FOOTER //
// ./src/containers/InsuranceCheckingContainer/InsuranceCheckingContainer.js